import Breadcrumb from "../../component/Breadcrumb"

const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"About Us",
      slug:"/about"
    }
  ]
}

export default function AboutNewHead() {
  return (
    <>
      <section className="about-new-head header-gap">
        <img src="/assets/home/about-new-head-vec.webp" alt="vector" className="img-responsive about-new-head-vec" />
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6 col-md-7 order-1 order-md-0">
              <Breadcrumb breadcrumbData={breadcrumbData}/>
              <div className="about-new-head-content about-shaper">
                <div className="wow animate__fadeInLeft" data-wow-duration={"1s"} data-wow-delay="0.2s">
                  <img src="/assets/home/about-new-headicon.webp" alt="icon" className="img-responsive" />
                  <h1 className="heading">About Us</h1>
                </div>
                <p className="wow animate__fadeInUp" data-wow-duration={"1s"} data-wow-delay="0.2s">At Mobility Infotech, we are more than a mobility service provider—we are your AI-driven innovation partner. With 5+ years of proven expertise, we design, scale, and deliver intelligent mobility ecosystems that help businesses, transport operators, and governments stay ahead in an increasingly connected world.</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 order-0 order-md-1">
              <div className="about-new-head-image">
                <img src="/assets/home/about-new-head.webp" alt="banner" className="img-responsive wow animate__fadeInRight" data-wow-duration={"1s"} data-wow-delay="0.2s"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
